const recipient = `
  fragment recipient on Beneficiary {
    name
    email
    mobile
    creditor {
      name
      identifier 
      city
      country
      postalCode
      stateOrProvince
      address
      accountType
    }
    paymentType {
      name
    }
  }
`

export {
  recipient
}
